import React from "react";
import { LegalPageShell } from "./Legal";

const Conditions = () => (
  <LegalPageShell id="conditions">
    <main id="main-content">
      <svg
        width="0"
        height="0"
        style={{ position: "absolute" }}
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <g id="blob-1" transform="translate(-100,-100)">
            <path d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z" />
            <path d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z" />
          </g>
          <g id="blob-2" transform="translate(100,-100) scale(-1,1)">
            <path d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z" />
            <path d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z" />
          </g>
        </defs>
      </svg>
      <header className="hero">
        <div className="hero-pattern" aria-hidden="true">
          <svg
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid slice"
            xmlns="http://www.w3.org/2000/svg"
          >
            <svg x="8%" y="20%" overflow="visible">
              <use
                href="#blob-2"
                fill="#B798F2"
                transform="scale(1.6)"
                opacity="0.16"
              />
            </svg>
            <svg x="82%" y="74%" overflow="visible">
              <use
                href="#blob-1"
                fill="#FFA5BC"
                transform="scale(1.8)"
                opacity="0.14"
              />
            </svg>
            <svg x="50%" y="-15%" overflow="visible">
              <use
                href="#blob-2"
                fill="#E8EBFF"
                transform="scale(1.4)"
                opacity="0.55"
              />
            </svg>
            <svg x="64%" y="58%" overflow="visible">
              <use
                href="#blob-1"
                fill="#F3EC7A"
                transform="scale(0.85)"
                opacity="0.30"
              />
            </svg>
          </svg>
        </div>
        <div className="container">
          <span className="eyebrow">Terms & Conditions</span>
          <h1 className="hero-title">
            The <em>rules</em>, in plain English.
          </h1>
          <p className="hero-sub">
            {" "}
            A short, readable contract.{" "}
            <strong>
              Be reasonable with us and we'll be reasonable back.
            </strong>{" "}
            The legal version follows underneath.{" "}
          </p>
          <div className="hero-meta" aria-label="Terms metadata">
            <span>
              <strong>Read time:</strong> about 10 minutes
            </span>
          </div>
        </div>
      </header>
      <section className="tldr-wrap" aria-labelledby="tldr-title">
        <div className="narrow">
          <div className="tldr">
            <div className="label">The whole thing in seven bullets</div>
            <h2 id="tldr-title">
              If you only read <em>one box</em>, this is it.
            </h2>
            <ul>
              <li>
                <strong>You can use 42courses</strong> if you're 16 or older and
                you stick to these rules.
              </li>
              <li>
                <strong>The lessons are ours.</strong> Your answers and posts
                are yours. We do not borrow each other's homework.
              </li>
              <li>
                <strong>Your work never trains AI.</strong> Yours or anyone
                else's. See section 09.
              </li>
              <li>
                <strong>Subscriptions renew until you stop them.</strong> Yearly
                passes and Community Hub tiers can be cancelled any time. The
                12-month payment plan is a payment plan, so it runs the 12
                months.
              </li>
              <li>
                <strong>30-day refund.</strong> If you aren't happy, we aren't
                happy. Email us and we'll sort it.
              </li>
              <li>
                <strong>Be decent</strong> in the Community Hub. We will not
                host bigotry, spam, or scraping.
              </li>
              <li>
                <strong>If we fall out,</strong> English law is the referee,
                sitting in the courts of England and Wales.
              </li>
            </ul>
          </div>
        </div>
      </section>
      <nav className="toc" aria-label="Jump to a section">
        <div className="container toc-inner">
          <span className="toc-label">Jump to:</span>
          <div className="toc-pills">
            <a href="#about-us" className="toc-pill">
              About us
            </a>
            <a href="#agreement" className="toc-pill">
              Your agreement
            </a>
            <a href="#account" className="toc-pill">
              Your account
            </a>
            <a href="#use" className="toc-pill">
              Acceptable use
            </a>
            <a href="#payments" className="toc-pill">
              Payments & renewals
            </a>
            <a href="#refunds" className="toc-pill">
              Refunds
            </a>
            <a href="#ip" className="toc-pill">
              Our IP
            </a>
            <a href="#your-content" className="toc-pill">
              Your content
            </a>
            <a href="#ai" className="toc-pill">
              AI
            </a>
            <a href="#community" className="toc-pill">
              Community Hub
            </a>
            <a href="#suspension" className="toc-pill">
              Suspension
            </a>
            <a href="#liability" className="toc-pill">
              Liability
            </a>
            <a href="#law" className="toc-pill">
              Governing law
            </a>
            <a href="#changes" className="toc-pill">
              Changes
            </a>
            <a href="#contact" className="toc-pill">
              Contact
            </a>
          </div>
        </div>
      </nav>
      <section id="about-us" aria-labelledby="about-us-title">
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">01</span>
            <h2 className="section-title" id="about-us-title">
              Who <em>we are</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              We are 42courses. We are a real, registered company in England and
              Wales. These terms come from us.{" "}
            </div>
          </div>
          <div className="prose">
            <p>
              These terms are issued by <strong>42COURSES.COM LIMITED</strong>,
              a company registered in England and Wales (referred to in these
              terms as <em>42courses</em>, <em>we</em>, <em>us</em>, and{" "}
              <em>our</em>
              ).
            </p>
            <ul>
              <li>
                <strong>Website:</strong>{" "}
                <a href="https://www.42courses.com">www.42courses.com</a>
              </li>
              <li>
                <strong>Email:</strong>{" "}
                <a href="mailto:groundcontrol@42courses.com">
                  groundcontrol@42courses.com
                </a>
              </li>
              <li>
                <strong>Registered office:</strong> D S Burge And Co Ltd, The
                Courtyard, 7 Francis Grove, London, SW19 4DW, United Kingdom
              </li>
              <li>
                <strong>Company number:</strong> 09650031 (registered in England
                and Wales)
              </li>
              <li>
                <strong>UK VAT number:</strong> GB227725792
              </li>
              <li>
                <strong>EU VAT number (OSS):</strong> EU372024684
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section
        id="agreement"
        aria-labelledby="agreement-title"
        style={{
          background: "var(--cream-ink)",
          borderTop: "1px solid var(--grey-200)",
          borderBottom: "1px solid var(--grey-200)",
        }}
      >
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">02</span>
            <h2 className="section-title" id="agreement-title">
              What you're <em>agreeing to</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              By signing up, you accept these terms. They form a contract
              between you and us. We've made it as short and readable as we can
              without leaving out anything that matters.{" "}
            </div>
          </div>
          <div className="prose">
            <p>
              By creating an account, buying a course, subscribing, or otherwise
              using 42courses, you agree to these terms. Together with our{" "}
              <a href="/privacy">Privacy Policy</a>, our{" "}
              <a href="/cookies">Cookie Policy</a> and any specific terms for a
              particular service, they form the contract between you and us.
            </p>
            <p>
              If you're using 42courses on behalf of an organisation (for
              example as part of a Team Plan), you confirm that you have
              authority to bind that organisation to these terms.
            </p>
            <p>
              If you don't agree with any of these terms, please don't use the
              platform. (We will not be offended; we'd just rather you knew
              where you stood.)
            </p>
          </div>
        </div>
      </section>
      <section id="account" aria-labelledby="account-title">
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">03</span>
            <h2 className="section-title" id="account-title">
              Your <em>account</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              One account per person. Keep your password safe. Tell us promptly
              if it's been compromised. Don't lend your login to the whole
              office.{" "}
            </div>
          </div>
          <div className="prose">
            <ul>
              <li>
                <strong>Age:</strong> You must be 16 or older to create an
                account.
              </li>
              <li>
                <strong>Honest details:</strong> The information you give us at
                signup should be accurate. If it changes, update it.
              </li>
              <li>
                <strong>One human, one account:</strong> Accounts are for
                individuals. Don't share your login with colleagues, family or
                anyone else. If you need access for a team, see our{" "}
                <a href="/team_plans">Team Plans</a>.
              </li>
              <li>
                <strong>Password hygiene:</strong> Keep your password to
                yourself. If you suspect someone else has it, change it and tell
                us at{" "}
                <a href="mailto:groundcontrol@42courses.com">
                  groundcontrol@42courses.com
                </a>
                .
              </li>
              <li>
                <strong>Responsibility:</strong> You're responsible for
                everything that happens under your account. If a friend logs in
                and starts a course, that's on you.
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section
        id="use"
        aria-labelledby="use-title"
        style={{
          background: "var(--cream-ink)",
          borderTop: "1px solid var(--grey-200)",
          borderBottom: "1px solid var(--grey-200)",
        }}
      >
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">04</span>
            <h2 className="section-title" id="use-title">
              Acceptable <em>use</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              Use the site the way it was meant to be used. Don't scrape it,
              don't break it, don't be unkind. We will notice.{" "}
            </div>
          </div>
          <div className="au-grid">
            <div className="au-card do">
              <h4>Do, please</h4>
              <ul>
                <li>Take courses, write thoughtful answers, learn things.</li>
                <li>Discuss ideas in the Community Hub.</li>
                <li>Share your certificates with employers and on LinkedIn.</li>
                <li>Tell us when you spot a bug or a typo.</li>
                <li>Tell us when a lesson lands well.</li>
              </ul>
            </div>
            <div className="au-card dont">
              <h4>Please don't</h4>
              <ul>
                <li>
                  Scrape the site, automate logins, or hammer our servers.
                </li>
                <li>Copy, republish, or resell our lesson content.</li>
                <li>
                  Use the platform to harass, defame, or discriminate against
                  anyone.
                </li>
                <li>Upload anything malicious or unlawful.</li>
                <li>Pretend to be someone you're not.</li>
              </ul>
            </div>
          </div>
          <div className="prose" style={{ marginTop: "16px" }}>
            <p>
              If you break these rules, we may suspend or close your account.
              For serious or repeated breaches, we may report them to the
              relevant authorities. (Reasonable doubt favours the user;
              persistent bad faith does not.)
            </p>
          </div>
        </div>
      </section>
      <section id="payments" aria-labelledby="payments-title">
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">05</span>
            <h2 className="section-title" id="payments-title">
              Payments & <em>renewals</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              We show prices in your local currency. Subscriptions renew
              automatically until you cancel. Payment plans are a payment plan,
              not a pause-and-resume subscription.{" "}
            </div>
          </div>
          <div className="prose">
            <h3>Prices and currency</h3>
            <p>
              Prices are shown in your local currency on the{" "}
              <a href="/courses">courses page</a>. The price you see at checkout
              is the price you pay, plus any applicable taxes shown before you
              confirm.
            </p>
            <h3>How we take payment</h3>
            <p>
              Payments are processed by Stripe and PayPal. We can also issue
              invoices for company purchases. Card numbers and CVVs are entered
              on Stripe's or PayPal's secure pages and never reach our servers.
            </p>
            <h3>The four ways to pay</h3>
            <ul>
              <li>
                <strong>Yearly All Access Pass (upfront):</strong> one annual
                payment, instant access to everything. Renews automatically each
                year at the same price as long as you stay subscribed.
              </li>
              <li>
                <strong>Yearly All Access Pass (12-month payment plan):</strong>{" "}
                the same access, billed in 12 equal monthly instalments,
                interest-free. It's a payment plan, not a pause-and-resume
                subscription, so the 12 monthly charges run their course once
                started.
              </li>
              <li>
                <strong>Individual courses:</strong> one-off payment. The course
                is yours to keep. Includes 3 months of Community Hub access.
              </li>
              <li>
                <strong>Community Hub only:</strong> a lower-cost monthly tier.
                Cancel any time; access stops at the end of the period you've
                paid for.
              </li>
            </ul>
            <h3>Renewals</h3>
            <p>
              Subscriptions renew automatically until you cancel them. We'll
              send you an email reminder before each renewal so it's never a
              surprise. You can cancel at any time from your account settings or
              by emailing us.
            </p>
            <h3>Failed payments</h3>
            <p>
              If a renewal payment fails, we'll email you with a link to update
              your payment method and complete the payment. Access pauses until
              that's done. We don't keep silently retrying the card.
            </p>
            <h3>Price changes</h3>
            <p>
              If we change the price of a tier, your existing subscription stays
              at the price you signed up at, for as long as you remain
              continuously subscribed. New customers pay the new price. (This
              isn't a sneaky way of locking you in; it's our way of rewarding
              you for sticking around.)
            </p>
          </div>
        </div>
      </section>
      <section
        id="refunds"
        aria-labelledby="refunds-title"
        style={{
          background: "var(--cream-ink)",
          borderTop: "1px solid var(--grey-200)",
          borderBottom: "1px solid var(--grey-200)",
        }}
      >
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">06</span>
            <h2 className="section-title" id="refunds-title">
              Refunds, <em>plainly</em>.
            </h2>
          </div>
          <div className="refund-pull">
            <h3>
              If you aren't happy, <em>we aren't happy.</em>
            </h3>
            <p>
              Email{" "}
              <a href="mailto:groundcontrol@42courses.com">
                <strong>groundcontrol@42courses.com</strong>
              </a>{" "}
              within 30 days of buying and we'll refund you. No interrogation,
              no exit survey, no awkward phone call.
            </p>
          </div>
          <div className="prose">
            <h3>The detail</h3>
            <ul>
              <li>
                <strong>30-day window:</strong> Refunds are available within 30
                days of your purchase or the start of a renewal period.
              </li>
              <li>
                <strong>How long it takes:</strong> Refunds appear on your card
                within 5 to 10 business days, depending on your bank.
              </li>
              <li>
                <strong>Partial completion:</strong> You can ask for a refund
                even if you've started the course. We trust people to ask in
                good faith.
              </li>
              <li>
                <strong>Course substantially complete:</strong> If you've
                already finished the entire course, you've seen everything we
                have to offer, so a refund isn't really a refund any more. We
                may politely decline in that case. (The alternative is printing
                free certificates, which is not a sustainable business model.)
              </li>
              <li>
                <strong>Gifts:</strong> If you bought a course as a gift and the
                recipient hasn't redeemed it, we can refund or transfer it.
              </li>
              <li>
                <strong>Team Plans:</strong> Refunds for Team Plans follow the
                terms of your team agreement; email us and we'll work it out.
              </li>
            </ul>
            <p>
              This refund policy is on top of any statutory rights you have
              under UK consumer law (including the Consumer Rights Act 2015 and
              the Consumer Contracts Regulations 2013), which it does not
              affect.
            </p>
            <div className="lawyer">
              <strong>For digital content:</strong> Under UK consumer law, by
              accessing a digital course, you may waive the standard 14-day
              cancellation right that applies to digital downloads. Our 30-day
              refund offer is more generous than that and applies regardless.
            </div>
          </div>
        </div>
      </section>
      <section id="ip" aria-labelledby="ip-title">
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">07</span>
            <h2 className="section-title" id="ip-title">
              Our <em>intellectual property</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              The lessons, videos, designs, frameworks and the platform itself
              are ours. We grant you a personal licence to use them. We don't
              grant you the right to copy and re-publish them.{" "}
            </div>
          </div>
          <div className="prose">
            <p>
              All course content (videos, written lessons, illustrations,
              frameworks, assessments, the AI personalisation engine, and the
              platform itself) is owned by 42courses or licensed to us by our
              co-creators. It is protected by copyright, trade mark, and
              database-right laws.
            </p>
            <p>
              When you buy a course or subscription, we grant you a{" "}
              <strong>
                personal, non-exclusive, non-transferable, revocable licence
              </strong>{" "}
              to access and use the content for your own learning. You may:
            </p>
            <ul>
              <li>Read, watch, and complete the lessons.</li>
              <li>Save personal notes.</li>
              <li>
                Share screenshots of small extracts on social media, with
                attribution.
              </li>
              <li>Print the certificate of completion you earn.</li>
            </ul>
            <p>You may not:</p>
            <ul>
              <li>Re-publish, redistribute, or resell the content.</li>
              <li>Use it to train AI models (yours or anyone else's).</li>
              <li>Strip the content of attribution or branding.</li>
              <li>Use it to build a competing learning product.</li>
            </ul>
            <p>
              If you'd like to use our content in a way that isn't covered above
              (for example, quoting a framework in a book), please ask. We are
              generally friendly to good-faith requests.
            </p>
          </div>
        </div>
      </section>
      <section
        id="your-content"
        aria-labelledby="your-content-title"
        style={{
          background: "var(--cream-ink)",
          borderTop: "1px solid var(--grey-200)",
          borderBottom: "1px solid var(--grey-200)",
        }}
      >
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">08</span>
            <h2 className="section-title" id="your-content-title">
              Your content <em>stays yours</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              Your answers, posts, and ideas are yours. We need a limited
              licence to host them and mark them. We don't take ownership of
              anything you write.{" "}
            </div>
          </div>
          <div className="prose">
            <p>
              You retain all intellectual property rights in the content you
              submit to 42courses (your lesson answers, your Community Hub
              posts, your replies, your uploaded files, your prompts to our AI
              tools).
            </p>
            <p>
              To run the platform, you grant us a{" "}
              <strong>limited, worldwide, royalty-free licence</strong> to host,
              store, display, and process your content solely for the purpose of
              providing the service to you and the community you have posted to.
              That licence ends when you delete the content or close your
              account, except where we are legally required to keep a record.
            </p>
            <p>
              We do not claim copyright in your answers. We do not sell,
              license, or syndicate your content to third parties. We do not use
              your content to train AI models. See section 09 for the detail on
              AI.
            </p>
            <h3>What you confirm when you post</h3>
            <ul>
              <li>
                The content you submit is yours to submit, or you have the right
                to submit it.
              </li>
              <li>It does not infringe anyone else's IP or privacy.</li>
              <li>
                It is not unlawful, threatening, defamatory, or grossly
                offensive.
              </li>
              <li>
                You're happy for it to be seen by the team member marking it
                (and, in the Community Hub, by other learners with the relevant
                access).
              </li>
            </ul>
            <p>
              If we receive a notice from someone claiming your content
              infringes their rights, we may take it down while we investigate,
              and we'll tell you about it. If you think we've taken your content
              down in error, write to us at{" "}
              <a href="mailto:groundcontrol@42courses.com">
                groundcontrol@42courses.com
              </a>{" "}
              and we'll review.
            </p>
          </div>
        </div>
      </section>
      <section id="ai" aria-labelledby="ai-title">
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">09</span>
            <h2 className="section-title" id="ai-title">
              AI <em>on 42courses</em>.
            </h2>
          </div>
          <div className="ai-card">
            <div className="ai-card-head">
              <span className="ai-card-badge">The short answer</span>
            </div>
            <h3>
              Your data is not training fuel. Not ours, not anyone else's.
            </h3>
            <div className="prose" style={{ marginTop: "12px" }}>
              <p>
                We use AI to personalise lessons around your role, location and
                goals, and to power the AI tools inside the Community Hub. The
                contractual rules we follow with our AI providers, and that you
                can rely on:
              </p>
              <ul>
                <li>
                  Your inputs and outputs are{" "}
                  <strong>not used to train any AI model</strong>, by us or by
                  our suppliers.
                </li>
                <li>
                  Your data is <strong>not retained</strong> by the AI provider
                  beyond the brief window needed to generate a response.
                </li>
                <li>
                  Your data is <strong>not shared</strong> with any third party
                  other than the AI processor that produces the personalised
                  text.
                </li>
                <li>
                  Your answers are <strong>not visible</strong> to other
                  learners.
                </li>
              </ul>
              <p>
                The full privacy detail lives in section 04 of our{" "}
                <a href="/privacy">Privacy Policy</a>.
              </p>
            </div>
          </div>
          <div className="prose">
            <h3>What AI does on 42courses</h3>
            <ul>
              <li>
                <strong>Lesson personalisation:</strong> rewrites the example
                layer of each lesson around your role, location and goals, while
                keeping the underlying frameworks, data and hard facts intact.
              </li>
              <li>
                <strong>Practical applications:</strong> at the end of each
                lesson, generates two, three or four practical ways you can
                apply the content to your own work.
              </li>
              <li>
                <strong>Tools in the Community Hub:</strong> creative briefing
                tools, behavioural science applicators, and others.
              </li>
            </ul>
            <h3>What AI does not do on 42courses</h3>
            <ul>
              <li>It does not mark your lesson answers. Humans do that.</li>
              <li>
                It does not change the facts, data or video content in a lesson.
              </li>
              <li>It does not generate certificates on its own.</li>
              <li>
                It does not study your data for any purpose other than producing
                the requested output.
              </li>
            </ul>
            <h3>Your responsibility when using our AI tools</h3>
            <p>
              AI outputs can occasionally be wrong, biased, or out of date.
              Treat them the way a sensible person would treat any draft: use it
              as a starting point, not a final answer. Don't feed confidential
              or sensitive data (your own or anyone else's) into our AI tools.
            </p>
            <p>
              If you'd rather not use AI personalisation at all, email us and
              we'll switch your account to a non-personalised mode. You'll still
              get the lessons; they just won't be tailored.
            </p>
          </div>
        </div>
      </section>
      <section
        id="community"
        aria-labelledby="community-title"
        style={{
          background: "var(--cream-ink)",
          borderTop: "1px solid var(--grey-200)",
          borderBottom: "1px solid var(--grey-200)",
        }}
      >
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">10</span>
            <h2 className="section-title" id="community-title">
              Community Hub <em>house rules</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              Sharper than your group chat, kinder than LinkedIn. We curate it
              on purpose.{" "}
            </div>
          </div>
          <div className="prose">
            <p>
              The Community Hub is a private space for learners and our team. To
              keep it useful, members agree to:
            </p>
            <ul>
              <li>
                <strong>Treat people well.</strong> Disagree about ideas; not
                about people.
              </li>
              <li>
                <strong>No spam, no scraping, no influencer pitches.</strong> We
                are not your launchpad.
              </li>
              <li>
                <strong>No discrimination, harassment, or hate speech.</strong>{" "}
                Including the polite versions.
              </li>
              <li>
                <strong>No confidential information</strong> belonging to your
                employer or anyone else's.
              </li>
              <li>
                <strong>Credit your sources.</strong> If you're quoting a
                thinker, name them.
              </li>
            </ul>
            <p>
              We reserve the right to remove posts or members who don't follow
              these rules. We try to be light-touch about it, but where a post
              is causing harm we'll move fast. If you think we've made the wrong
              call, tell us.
            </p>
            <h3>You are responsible for what you post</h3>
            <p>
              Everything you upload, paste, share, or describe in the Community
              Hub is your responsibility, not ours. That includes work files,
              internal slide decks, client briefs, proprietary research,
              customer data, and anything else covered by a confidentiality
              obligation you owe to someone else.
            </p>
            <p>
              If you share something you shouldn't have,{" "}
              <strong>that is between you and whoever owns it</strong>.
              42courses is not liable for any breach of confidentiality, IP,
              privacy, or NDA that arises from your decision to post the
              material. Tell us straight away and we will remove it as fast as
              we can, but the underlying disclosure is on you.
            </p>
            <div className="lawyer">
              <strong>Why this is here:</strong> people occasionally paste
              things into chat windows they later wish they hadn't. We can take
              it down; we can't unsend it. This clause makes that division of
              responsibility explicit.
            </div>
          </div>
        </div>
      </section>
      <section id="suspension" aria-labelledby="suspension-title">
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">11</span>
            <h2 className="section-title" id="suspension-title">
              Suspending or <em>closing accounts</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              You can close your account whenever you like. We can close yours
              if you break the rules, but we always try a conversation first.{" "}
            </div>
          </div>
          <div className="prose">
            <h3>You closing your account</h3>
            <p>
              You can close your account at any time from your account settings,
              or by emailing{" "}
              <a href="mailto:groundcontrol@42courses.com">
                groundcontrol@42courses.com
              </a>
              . Any subscription cancels at the end of the period you've paid
              for. Courses you have already passed remain accessible to you in
              your archive; certificates you have earned are yours to keep.
            </p>
            <h3>Us suspending or closing your account</h3>
            <p>We may suspend or close your account if:</p>
            <ul>
              <li>
                You materially breach these terms, in particular the acceptable
                use rules (section 04) or community rules (section 10).
              </li>
              <li>We are required to by law or a court order.</li>
              <li>
                Payment fails repeatedly and you don't respond to our reminders.
              </li>
              <li>We reasonably suspect fraud.</li>
            </ul>
            <p>
              Where the breach is fixable, we will try to contact you first and
              give you a reasonable chance to put it right. Where it isn't
              (clear fraud, clear malice, clear illegality), we may act
              immediately.
            </p>
            <h3>What happens to your data</h3>
            <p>
              See section 08 of our{" "}
              <a href="/privacy#retention">Privacy Policy</a> for retention
              rules. In short: we keep what we have to (mostly tax records),
              delete what we don't need, and we'll send you a copy of your
              account data if you ask within 30 days of closure.
            </p>
          </div>
        </div>
      </section>
      <section
        id="liability"
        aria-labelledby="liability-title"
        style={{
          background: "var(--cream-ink)",
          borderTop: "1px solid var(--grey-200)",
          borderBottom: "1px solid var(--grey-200)",
        }}
      >
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">12</span>
            <h2 className="section-title" id="liability-title">
              Disclaimers & <em>liability</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              We do our best to keep the site working and the content accurate.
              Where things go wrong, the limits below kick in. Nothing here
              removes rights you have under UK consumer law.{" "}
            </div>
          </div>
          <div className="prose">
            <h3>What we promise</h3>
            <p>
              We promise to provide the platform and courses with reasonable
              care and skill, in line with the standard expected of a UK
              provider of online education. We promise to keep the site
              available with reasonable uptime, accepting that the internet,
              like the weather, has occasional bad days.
            </p>
            <h3>What we don't promise</h3>
            <ul>
              <li>
                That every lesson, in every personalised form, will be 100% free
                of error or out-of-date examples. (We fix things as we find
                them. Tell us if you spot one.)
              </li>
              <li>
                That using 42courses will lead to a specific career outcome,
                promotion, or salary increase. Learning helps. Magic isn't on
                the syllabus.
              </li>
              <li>
                That the site will always be online. We aim for high uptime, but
                planned and unplanned downtime happen.
              </li>
              <li>
                That third-party services we integrate with will always work
                (Stripe, PayPal, our email provider, our AI providers). When
                they break, we hustle to fix it.
              </li>
            </ul>
            <h3>Limitation of liability</h3>
            <p>To the maximum extent permitted by law:</p>
            <ul>
              <li>
                We are not liable for indirect or consequential losses, loss of
                profits, loss of business, loss of data, or loss of opportunity.
              </li>
              <li>
                Our total liability to you in connection with these terms, in
                any 12-month period, is limited to the amount you paid us in
                that 12-month period.
              </li>
              <li>
                Nothing in these terms excludes or limits our liability for
                death or personal injury caused by our negligence, fraud,
                fraudulent misrepresentation, or any liability that cannot be
                excluded under UK law.
              </li>
            </ul>
            <div className="lawyer">
              <strong>Why this is here:</strong> Every legal team in the country
              insists on a paragraph like this one. We've tried to keep it short
              and readable. None of it removes your statutory rights under UK
              consumer law.
            </div>
          </div>
        </div>
      </section>
      <section id="law" aria-labelledby="law-title">
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">13</span>
            <h2 className="section-title" id="law-title">
              Governing <em>law</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text">
              {" "}
              If we ever fall out, English law is the referee, sitting in the
              courts of England and Wales.{" "}
            </div>
          </div>
          <div className="prose">
            <p>
              These terms are governed by the laws of England and Wales. Any
              dispute arising out of or in connection with them, including their
              existence, validity, or termination, is subject to the exclusive
              jurisdiction of the courts of England and Wales.
            </p>
            <p>
              If you are a consumer based outside England and Wales, this clause
              does not deprive you of the protection of your local consumer-law
              rules.
            </p>
            <h3>Severability</h3>
            <p>
              If a court rules that any part of these terms is unenforceable,
              the rest still stands. (The bath is still useful when the rubber
              duck is missing.)
            </p>
            <h3>Entire agreement</h3>
            <p>
              These terms, together with our{" "}
              <a href="/privacy">Privacy Policy</a>, our{" "}
              <a href="/cookies">Cookie Policy</a>, and any specific terms for a
              particular service, form the entire agreement between you and
              42courses on the subject they cover.
            </p>
            <h3>No waiver</h3>
            <p>
              If we don't enforce a right immediately, that does not mean we
              have waived it. We just hadn't got round to it yet.
            </p>
            <h3>Assignment</h3>
            <p>
              You may not transfer your rights or obligations under these terms
              without our written consent. We may transfer ours, for example as
              part of a sale of the business, provided your rights as a customer
              aren't reduced.
            </p>
          </div>
        </div>
      </section>
      <section
        id="changes"
        aria-labelledby="changes-title"
        style={{
          background: "var(--cream-ink)",
          borderTop: "1px solid var(--grey-200)",
          borderBottom: "1px solid var(--grey-200)",
        }}
      >
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">14</span>
            <h2 className="section-title" id="changes-title">
              Changes <em>to these terms</em>.
            </h2>
          </div>
          <div className="plain">
            <span className="plain-tag">In plain English</span>
            <div className="plain-text"> We'll tell you. We won't sneak. </div>
          </div>
          <div className="prose">
            <p>
              We may update these terms from time to time, usually because we've
              added a new feature, changed a supplier, or improved a policy.
              When we do, we'll change the version on this page.
            </p>
            <p>
              For material changes, we will email you and give you at least 30
              days' notice before the change takes effect. If you don't agree
              with a change, you can close your account before it takes effect,
              and (where applicable) request a pro-rated refund. The 30-day
              refund clause in section 06 still applies on top of this.
            </p>
          </div>
        </div>
      </section>
      <section id="contact" aria-labelledby="contact-title-section">
        <div className="narrow">
          <div className="section-head">
            <span className="section-num">15</span>
            <h2 className="section-title" id="contact-title-section">
              Contacting <em>us</em>.
            </h2>
          </div>
          <div className="contact-box">
            <h3>
              One inbox, <em>one team, one human reply</em>.
            </h3>
            <p>
              Questions about these terms, refund requests, anything else: email{" "}
              <a href="mailto:groundcontrol@42courses.com">
                groundcontrol@42courses.com
              </a>
              . We reply within 24 hours, often sooner.
            </p>
            <p>
              For postal mail, write to us at our registered office (listed in
              section 01). For data and privacy matters specifically, see our{" "}
              <a href="/privacy">Privacy Policy</a>.
            </p>
          </div>
        </div>
      </section>
    </main>
    <section className="still-got-q" aria-labelledby="still-q-title">
      <div className="container">
        <h2 id="still-q-title">
          Still got a <em>question</em>?
        </h2>
        <p>
          If we haven't covered yours, send a real human at 42courses an email.
          We reply within 24 hours, often sooner.
        </p>
        <div className="btn-row">
          <a
            href="mailto:groundcontrol@42courses.com"
            className="btn btn-primary"
          >
            Email Ground Control
          </a>
          <a href="/faqs" className="btn btn-secondary">
            Read the FAQs
          </a>
        </div>
      </div>
    </section>
    <footer className="footer-egg">
      <div className="big">
        <em>Don't panic.</em>
      </div>
      <div className="small">
        These are just the rules. You're still here for the courses.
      </div>
      <div className="version">Version: 12 May 2026</div>
    </footer>
  </LegalPageShell>
);

export default Conditions;
